<template>
  <div>
    <opq-basic-appbar>Ordre des psychologues du Québec - Création de compte portail</opq-basic-appbar>
    <v-main>
      <v-card max-width="960" class="pa-4 pa-md-12 my-md-12 my-0 mx-auto">
        <creation-de-compte class="mx-3 mx-md-auto" />
      </v-card>
    </v-main>
  </div>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
import CreationDeCompte from "@/components/CreationDeCompte/master.vue"
export default {
  mixins: [AppbarBase],
  components: {
    CreationDeCompte
  }
}
</script>

<style lang="scss">
html {
  overflow: auto;
}
</style>

